import { ToastContext } from "@/providers/ToastProvider";
import type { ToastProviderProps } from "@/types/providers/toast";

import { useContext } from "react";

export default function useToast() {
  const context = useContext(ToastContext) as ToastProviderProps;
  if (!context) throw new Error("useToast must be used within an ToastProvider");
  return context;
}
